import { mapActions, mapGetters, mapMutations } from "vuex";
import {
    GET_PROPS_SELECTION,
    GET_ALL_FILTERS,
    CHECK_COUNT_PRODUCTS
} from '@/store/action-types';
import {
    PROPS_SELECTION_CHANGE_SKIP,
    PROPS_SELECTION_RESET_ALL,
    PROPS_SELECTION_CHANGE_RESET_ALL,
    PROPS_SELECTION_CHANGE_PRICE,
    SET_COUNT_PRODUCTS
} from '@/store/mutation-types';
import PropsSelect from './components/select/index.vue';
import Product from '@/components/product/index.vue';

import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination';
import '@/../node_modules/@fortawesome/fontawesome-free/css/all.css';
import '@/../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';
import _ from "lodash";
export default {
    name: 'selection-props',
    breadcrumb() {
        return {
            label: this.$t('selectionProps'),
            parentsList: [
                {
                    path: '/',
                    label: this.$t('main'),
                    name: 'home'
                }
            ]
        }
    },
    data(){
      return{
          page: 0,
          minPrice: '',
          maxPrice: '',
          params: {
              title: '',
              description: '',
              keywords: '',
              image: ''
          },
      }
    },
    head: {
        meta: function () {
            let meta = [
                { n: 'description', c: this.params.description, id: 'description' },
                { n: 'keywords', c: this.params.keywords, id: 'keywords' },
                { n: 'og:title', c: this.params.title, id: 'og:title' },
                { n: 'og:description', c: this.params.description, id: 'og:description' },
            ]

            if (Object.keys(this.$route.query).length > 0) {
                meta.push({ n: 'robots', c: 'noindex, nofollow' })
                return meta
            } else {
                return meta
            }
        },
        link: function () {
            let route = this.$route.path
            return [
                { rel: 'canonical', href: window.location.origin + this.$route.path, id: 'canonical' },
            ]
        }
    },
    components: {
        PropsSelect,
        VueAdsPagination,
        VueAdsPageButton,
        Product,
    },
    computed: {
        ...mapGetters({
            listLoading: 'propsSelection/listLoading',
            checkedList: 'propsSelection/checkedList',
            list: 'propsSelection/list',
            length: 'propsSelection/count',
            limit: 'propsSelection/limit',
            skip: 'propsSelection/skip',

            countProducts: 'propsSelection/countProducts',
            countProductsLoading: 'propsSelection/countProductsLoading',

            filters: 'propsSelection/filters',
            filtersLoading: 'propsSelection/filtersLoading',

            price: 'propsSelection/price',
        }),
        changeWord(){
            let titles = [this.$t('basketProducts'), this.$t('basketProducts1'), this.$t('basketProducts2')];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[ (this.countProducts%100>4 && this.countProducts%100<20)? 2 : cases[(this.countProducts%10<5)?this.countProducts%10:5] ];
        },
        disabledBtn(){
            if(this.checkedList.length === 0 && this.price.min === '' && this.price.max === ''){
                return true
            }
            return false
        }
    },
    created(){
        if(this.length){
            if(this.length > 0){
                this.page = this.skip / this.limit;
            }
        }
        if(!this.filters){
            this.fetchFilters();
        }
    },
    methods: {
        ...mapActions({
            fetchList: `propsSelection/${GET_PROPS_SELECTION}`,
            fetchFilters: `propsSelection/${GET_ALL_FILTERS}`,
            checkCount: `propsSelection/${CHECK_COUNT_PRODUCTS}`
        }),
        ...mapMutations({
            changeSkip: `propsSelection/${PROPS_SELECTION_CHANGE_SKIP}`,
            resetFilter: `propsSelection/${PROPS_SELECTION_RESET_ALL}`,
            changeResetFilter: `propsSelection/${PROPS_SELECTION_CHANGE_RESET_ALL}`,
            changePrice: `propsSelection/${PROPS_SELECTION_CHANGE_PRICE}`,
            setCount: `propsSelection/${SET_COUNT_PRODUCTS}`,
        }),
        submit(){
            let transformObj = {};
            this.checkedList.forEach(e => {
                transformObj[e.slug] = e.categories.map(t => {
                    return t.slug;
                });

            });
            transformObj.price_min = this.price.min;
            transformObj.price_max = this.price.max;
            this.page = 0;
            this.fetchList(transformObj);
        },
        reset(){
            this.minPrice = '';
            this.maxPrice = '';
            this.changePrice({
                min: '',
                max: '',
            })
            this.resetFilter();
            this.changeResetFilter(true);
        },
        changePriceInput(){
            this.changePrice({
                min: this.minPrice,
                max: this.maxPrice,
            });

            if(this.checkedList.length === 0 && this.price.min === '' && this.price.max === ''){
                this.setCount(0)
            }else{
                this.updateCountResult();
            }
        },
        updateCountResult: _.debounce(function () {
            let transformObj = {};
            this.checkedList.forEach(e => {
                transformObj[e.slug] = e.categories.map(t => {
                    return t.slug;
                });
            });
            transformObj.price_min = this.price.min;
            transformObj.price_max = this.price.max;
            this.checkCount(transformObj).finally(() => {
                if(this.checkedList.length === 0 && this.price.min === '' && this.price.max === ''){
                    this.setCount(0)
                }
            });
        }, 800),
        changePage(page){
            this.page = page;
            this.changeSkip(this.page * this.limit);
            let transformObj = {};
            this.checkedList.forEach(e => {
                transformObj[e.slug] = e.categories.map(t => {
                    return t.slug;
                });

            });
            this.fetchList(transformObj);
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }
    }
}
